import * as React from 'react';

function Rfid(props) {
  return (
    <svg width={45} height={43} {...props}>
      <g transform="translate(2 1)" fill="none" fillRule="evenodd">
        <circle
          fill="#3EC3EB"
          opacity={0.114}
          cx={20.698}
          cy={20.698}
          r={20.698}
        />
        <path
          d="M32.553 12.847H9.556c-.94 0-1.705.783-1.705 1.747v12.921c0 .964.764 1.747 1.705 1.747h22.997c.94 0 1.705-.783 1.705-1.747V14.594c-.03-.964-.764-1.747-1.705-1.747zm-20.27 13.531c-.087.09-.205.09-.293 0a3.162 3.162 0 010-4.427c.088-.09.206-.09.294 0 .03.03.059.09.059.15s-.03.12-.06.15a2.755 2.755 0 000 3.826c.09.09.09.21 0 .301zm.846-.934c.089.09.089.211 0 .302-.088.09-.206.09-.294 0-.764-.783-.764-2.079 0-2.892.088-.09.206-.09.294 0 .03.03.06.09.06.15 0 .061-.03.121-.06.151-.617.663-.617 1.687 0 2.29zm.574-.963c.088.09.088.21 0 .3-.088.091-.206.091-.294 0a.962.962 0 010-1.324c.088-.09.206-.09.294 0 .03.03.059.09.059.15s-.03.12-.06.15c-.176.181-.176.513 0 .724zm20.026-4.556H8.38v-3.102H33.7v3.102h.029z"
          fill="#18283C"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default Rfid;



// WEBPACK FOOTER //
// ./src/common/icons/Assets/RFID/RFID.js